



























































































import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "App",

  components: {},

  data: () => ({
    drawer: null
  }),

  computed: {
    ...mapGetters("users", [
      "fullName",
      "isAuthenticated",
      "avatarUrl",
      "isAdmin",
      "userHasLoaded"
    ]),
    items() {
      return [
        {
          icon: "mdi-account",
          text: this.isAuthenticated ? "Profile" : "Login",
          link: "/profile"
        },
        {
          icon: "mdi-camera",
          text: "Artwork",
          link: "/",
          hidden: !this.isAuthenticated
        },
        {
          icon: "mdi-chevron-right",
          "icon-alt": "mdi-chevron-down",
          text: "Admin",
          hidden: !this.isAdmin,
          model: true,
          children: [
            {
              icon: "mdi-account-multiple",
              text: "Users",
              link: "/admin/users"
            }
          ]
        }
        // { icon: "mdi-cog", text: "Settings" },
        // { icon: "mdi-message", text: "Send feedback" },
        // { icon: "mdi-help-circle", text: "Help" },
        // { icon: "mdi-cellphone-link", text: "App downloads" },
        // { icon: "mdi-keyboard", text: "Go to the old version" }
      ];
    }
  }
});
